<template>
<v-container>
  <v-badge
          color="cyan"
          left
        >
          <template v-slot:badge>
            <span>{{seats}}</span>
          </template>
          <v-icon
            large
            color="grey lighten-1"
          >mdi-chair-school</v-icon>
        </v-badge>
             <v-badge
          color="cyan"
          right
        >
          <template v-slot:badge>
            <span>{{bookings}}</span>
          </template>
          <v-icon
            large
            color="grey lighten-1"
          >mdi-account-multiple</v-icon>
        </v-badge>
  </v-container>
</template>

<script>
export default {
    name:'HtTrainingBadge',
    props:{
        seats:{
            type:Number,
            default:'',
        },
        bookings:{
            type:Number,
            default:'',
        }
    }
}
</script>

<style scoped>
  .container{
    width:100px;
  }
</style>